export const INVOICE_TAG_TYPES = {
  INVOICE: "Invoice",
  INVOICE_CONFIG: "InvoiceConfig",
  INVOICE_LIST: "InvoiceList",
} as const;

export const getInvoiceListTag = (entityId: string) => [
  { type: INVOICE_TAG_TYPES.INVOICE_LIST, id: entityId },
  { type: INVOICE_TAG_TYPES.INVOICE, id: "LIST" },
];

export const getInvoiceIdTag = (invoiceId: string) => [
  { type: INVOICE_TAG_TYPES.INVOICE, id: invoiceId },
];

export const getInvoiceConfigListTag = (entityId: string) => [
  { type: INVOICE_TAG_TYPES.INVOICE_CONFIG, id: entityId },
  { type: INVOICE_TAG_TYPES.INVOICE_CONFIG, id: "LIST" },
];

export const getInvoiceConfigTag = (configId: string) => [
  { type: INVOICE_TAG_TYPES.INVOICE_CONFIG, id: configId },
];
